import { StateCreator } from 'zustand'
import { ControllerStore, TableType } from '../../@types/store'

export type NatureType = {
  data: any[];
  columns: any[];
  next: string | null;
  previous: boolean | null;
  count: number;
}

const createControllerSlice: StateCreator<
  ControllerStore,
  [["zustand/devtools", never]],
  [],
  ControllerStore
> = (set) => ({
  controllerLoading: false,
  controller: { columns: [], data: [], next: null, count: 0, previous: null },
  nature: { columns: [], data: [], next: null, count: 0, previous: null },
  filters: "",
  setControllerLoading: (controllerLoading: boolean) => set(() => ({ controllerLoading: controllerLoading }), false, 'setControllerLoading'),
  setController: (data: TableType) => set(() => ({ controller: data }), false, 'setController'),
  setNature: (data: TableType) => set(() => ({ nature: data }), false, 'setNature'),
  setControllerFilters: (filters: string) => set(() => ({ filters: filters }), false, 'setControllerFilters'),
  setControllerColumnFilters: (column: string, values: object[]) => set((state) => ({
    controller: { ...state.controller, columns: state.controller.columns.map(item => item.dataIndex === column ? { ...item, values: values } : item) }
  }), false, 'setControllerColumnFilters'),
  setNatureColumnFilters: (column: string, values: object[]) => set((state) => ({
    nature: { ...state.nature, columns: state.nature.columns.map(item => item.dataIndex === column ? { ...item, values: values } : item) }
  }), false, 'setNatureColumnFilters')
})

export default createControllerSlice
